import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const DumbbellIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M3 3C2.44771 3 2 3.44772 2 4V6C1.44771 6 1 6.44772 1 7V9C1 9.55228 1.44771 10 2 10V12C2 12.5523 2.44771 13 3 13H4C4.55229 13 5 12.5523 5 12V4C5 3.44772 4.55229 3 4 3H3Z"
		></path>
		<path
			fill="currentColor"
			d="M12 3C11.4477 3 11 3.44772 11 4V12C11 12.5523 11.4477 13 12 13H13C13.5523 13 14 12.5523 14 12V10C14.5523 10 15 9.55228 15 9V7C15 6.44772 14.5523 6 14 6V4C14 3.44772 13.5523 3 13 3H12Z"
		></path>
		<path fill="currentColor" d="M10 7H6V9H10V7Z"></path>
	</svg>
))
